import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Article Summarizer" link="https://github.com/JDRanpariya/Article_Summarizer" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
My First Full Stack Project to Summarize article Using huggingface Transformers
    </ProjectCard>
    <ProjectCard title="Python Projects" link="https://github.com/jdranpariya/python_projects" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
I do lot of cool stuff with python which you can find here ( webdev, ML, DL, Scraping )
    </ProjectCard>
    <ProjectCard title="Data Mining" link="https://github.com/JDRanpariya/COVID-19-Windows-Notification" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This are my Data Mining Projects a.k.a Data Collection and storing it to databases, csv, gsheets etc.
    </ProjectCard>
    <ProjectCard title="Front-end Projects" link="https://github.com/JDRanpariya/frontend_projects" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
I love Javascript this are some of the interesting client side sites created by me.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      